import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import LanguageProvider from "./Provider/LanguageProvider";
import UserProvider from "./Provider/UserProvider";
import AssetProvider from "./Provider/AssetProvider";
import { Footer } from "./Footer";
import { PAGE_PATH } from "./Common";

ReactDOM.render(
  [
    <div key={1} className="content">
      <LanguageProvider>
        <UserProvider>
          <AssetProvider>
            <React.StrictMode>
              <Router basename={"/" + PAGE_PATH + "/"}>
                <App />
              </Router>
            </React.StrictMode>
          </AssetProvider>
        </UserProvider>
      </LanguageProvider>
    </div>,
    <Footer key={2} />,
  ],
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
